<div class="row card-body p-3 text-dark fw-bold" [formGroup]="personalDataForm">
    <h5>Datos Personales</h5>
    <div class="mt-2 col-lg-3 col-sm-6">
        <label for="rut" class="fw-bold">RUT</label>
        <input type="text" class="form-control" formControlName="rut" id="rut" placeholder="Sin puntos ni guión"
            (blur)="setDigitVerificator()">
        @if(personalDataForm.get('rut').touched && personalDataForm.get('rut').invalid){
        <small class="text-danger">Dato Obligatorio</small>
        }

    </div>
    <div class="mt-2 col-lg-1 col-sm-6">
        <label class="fw-bold">DV</label>
        <span class="form-control-plaintext border-bottom px-2">{{this.personalDataForm.value.dv ? this.personalDataForm.value.dv : '-'}}</span>
    </div>
    <div class="mt-2 col-xxl-2 col-lg-4 col-sm-6">
        <label for="names" class="fw-bold">Nombres</label>
        <input type="text" class="form-control" formControlName="names" id="names" placeholder="Nombres"
            (blur)="capitalize('names')">
        @if(personalDataForm.get('names').touched && personalDataForm.get('names').invalid){
        <small class="text-danger">Dato Obligatorio</small>
        }
    </div>
    <div class="mt-2 col-xxl-2 col-lg-4 col-sm-6">
        <label for="surname" class="fw-bold">Apellido Paterno</label>
        <input type="text" class="form-control" formControlName="surname" id="surname" placeholder="Apellido Paterno"
            (blur)="capitalize('surname')">
        @if(personalDataForm.get('surname').touched && personalDataForm.get('surname').invalid){
        <small class="text-danger">Dato Obligatorio</small>
        }
    </div>
    <div class="mt-2 col-xxl-2 col-lg-4 col-sm-6">
        <label for="lastname" class="fw-bold">Apellido Materno</label>
        <input type="text" class="form-control" formControlName="lastname" id="lastname"
            placeholder="Apellido Materno" (blur)="capitalize('lastname')">
        @if(personalDataForm.get('lastname').touched && personalDataForm.get('lastname').invalid){
        <small class="text-danger">Dato Obligatorio</small>
        }
    </div>
    <div class="mt-2 col-xl-2 col-lg-4 col-sm-6">
        <label for="birthdate" class="fw-bold">Fecha Nacimiento</label>
        <input type="date" class="form-control" formControlName="birthdate" id="birthdate" [max]="maxDate" [min]="minDate">

        @if(personalDataForm.get('birthdate').touched && personalDataForm.get('birthdate').hasError('notAdult')){
        <small class="text-danger">Debe ser mayor de edad</small>
        }@else if(personalDataForm.get('birthdate').touched &&
        personalDataForm.get('birthdate').hasError('futureDate')){
        <small class="text-danger">No puede ser una fecha posterior a hoy</small>
        }
    </div>

    <div class="mt-2 col-xl-2 col-lg-4 col-sm-6">
        <label for="genderId" class="fw-bold">Género</label>
        <ng-select [items]="listGenders" bindLabel="name" bindValue="_id" formControlName="genderId" id="genderId"> </ng-select>
        @if(personalDataForm.get('genderId').touched && personalDataForm.get('genderId').invalid){
        <small class="text-danger">Dato Obligatorio</small>
        }
    </div>

    <div class="mt-2 col-lg-4 col-sm-6">
        <label for="phone" class="fw-bold">Teléfono Celular</label>
        <input type="text" class="form-control" formControlName="phone" id="phone" placeholder="569XXXXXXXX">
        @if(personalDataForm.get('phone').touched &&
        personalDataForm.get('phone').hasError('phoneInvalid')){
        <small class="text-danger">Formato inválido</small>
        }
    </div>
    <div class="mt-2 col-xl-6 col-lg-8 col-sm-12">
        <label for="mail" class="fw-bold">Correo</label>
        <input type="email" class="form-control" formControlName="mail" id="mail" placeholder="Correo de contacto">
        @if(personalDataForm.get('mail').touched && personalDataForm.get('mail').invalid){
        <small class="text-danger">Dato Obligatorio</small>
        }
    </div>
</div>

<div class="modal-footer d-flex justify-content-end gap-2 flex-wrap">
    <button class="btn btn-outline-danger btn-xs" (click)="cancel.emit()"><i class="fas fa-times"></i> Cancelar</button>
    <button class="btn btn-primary btn-xs" (click)="save()"><i class="fas fa-save"></i> Guardar y Continuar <i class="fas fa-arrow-right"></i></button>
</div>